// This file is deprecated - use supabase.ts instead
import { supabase } from './supabase';
export { supabase as db };
export const isOfflineMode = false;
export const isInitialized = true;
export const initializationPromise = Promise.resolve();